/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import i18n from "../../plugins/locale/i18n";
import loadDictionary from "../../plugins/locale/load-dictionary";
import UserService from "../../service/user-service.js";
import RoleService from "../../service/role-service.js";

const userService = new UserService();
const roleService = new RoleService();

await loadDictionary('user-edit-user-window');

function EditUserWindow({isOpenWindow, onCloseWindow, userId}) {
  const [id, setId] = useState(0);
  const [roleId, setRoleId] = useState();
  const [name, setName] = useState('');
  const [mobile, setMobile] = useState('');
  const [isActive, setIsActive] = useState(false);
  const [roles, setRoles] = useState([]);

  const handleClose = () => {
    setId(0);
    setRoleId();
    setName('');
    setMobile('');
    setIsActive(false);

    onCloseWindow();
  };
  
  const handleSubmit = () => {
    const user = {
      id: parseInt(id),
      role_id: parseInt(roleId),
      name: name,
      mobile: mobile,
      is_active: isActive
    };

    userService.edit(user).then(result => {
      if(result) {
        handleClose();
      }
    }).catch(error => {
      console.error(error);
    });
  };

  useEffect(() => {
    if(!isOpenWindow || !userId) return;
    
    roleService.findAll().then(setRoles);
    userService.findOne(userId).then(user => {
      if(user) {
        setId(user.id);
        setName(user.name);
        setRoleId(user.role_id);
        setMobile(user.mobile);
        setIsActive(user.is_active);
      }
    });
  }, [isOpenWindow, userId]);

  return (
    <Modal show={isOpenWindow} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>{i18n.t("user-edit-user-window.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form method="POST" id="EditForm" onSubmit={e => {e.preventDefault(); handleSubmit()}}>
          <div className="row">
            <Form.Group className="mb-3 col" controlId="">
              <Form.Label>{i18n.t("user-edit-user-window.name")}</Form.Label>
              <Form.Control type="text" value={name} onChange={e => {setName(e.target.value)}}></Form.Control>
            </Form.Group>
          </div>
          <div className="row">
            <Form.Group className="mb-3 col" controlId="">
              <Form.Label>{i18n.t("user-edit-user-window.mobile")}</Form.Label>
              <Form.Control type="text" dir="ltr" value={mobile} onChange={e => {setMobile(e.target.value)}}></Form.Control>
            </Form.Group>
          </div>
          <div className="row">
            <Form.Group className="mb-3 col" controlId="">
              <Form.Label>{i18n.t("user-edit-user-window.role")}</Form.Label>
              <Form.Select value={roleId} onChange={e => {setRoleId(e.target.value)}}>
                {roles.map(role => <option key={role.id} value={role.id}>{role.name}</option>)}
              </Form.Select>
            </Form.Group>
          </div>
          <div className="row">
            <div className="my-3 col">
              <Form.Check type="checkbox" checked={isActive} onChange={e => {setIsActive(e.target.checked)}} label={i18n.t("user-edit-user-window.is_active")}/>
            </div>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>{i18n.t("user-edit-user-window.cancel_button")}</Button>
        <Button variant="primary" type="submit" form="EditForm" >{i18n.t("user-edit-user-window.create_button")}</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EditUserWindow;